import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '',
      component: () => import('../views/HomePage')
    },{
      path: '/green',
      component: () => import('../views/GreenPage')
    },{
      path: '/index',
      component: () => import('../views/HomePage')
    },{
      path: '/service',
      component: () => import('../views/ServicePage')
    },{
      path: '/plan',
      component: () => import('../views/PlanPage')
    },{
      path: '/news',
      component: () => import('../views/NewsPage')
    },,{
      path: '/content',
      component: () => import('../views/NewsContent')
    },{
      path: '/about',
      component: () => import('../views/AboutPage')
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js